package com.klantenstop.web.data.models.dto.requests.reviews

import kotlinx.serialization.Serializable

@Serializable
data class InsertReview(
    val text: String = "",
    val rating: Int = 0,
) {
    @Suppress("MagicNumber")
    val isValid
        get() = text.isNotBlank() && rating in 0..5
}
